import React from "react";
import GuideSection from "../../components/guide/GuideSection";
import { nextStepsGuide } from "../../components/guide/guideContent";
import { Container, Button } from "react-bootstrap";
import Header from "../../components/header/Header";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";

function FormalityFinalization() {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;

  return (
    <Container
      fluid
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        paddingLeft: "15px",
        paddingRight: "15px",
      }}
    >
      <Header />
      <Confetti
        width={isMobile ? window.innerWidth : window.innerWidth}
        height={isMobile ? window.innerHeight : window.innerHeight}
        numberOfPieces={100}
      />

      <h4 className="my-3 mt-4">
        Félicitations ! Votre <span style={{ color: "#FF5500" }}>commande</span>{" "}
        a été validée.
      </h4>

      <div className="container mb-3 text-center" style={{ maxWidth: "800px" }}>
        <p className="text-lg mb-1">
          Nous avons bien reçu votre commande et un e-mail de confirmation vient
          de vous être envoyé.
        </p>
        <p className="text-lg mb-1">
          {/* Buttons */}
          <div className="d-flex justify-content-center mt-4 g-3 flex-column flex-sm-row">
            <div className="col-auto my-2">
              <Button
                variant="outline-primary"
                style={{
                  width: "200px",
                }}
                size="sm"
                className="me-3"
                onClick={() => navigate("/")}
              >
                Retourner à la page d'accueil
              </Button>
            </div>
            <div className="col-auto my-2">
              <Button
                style={{
                  backgroundColor: "#FF5500",
                  borderColor: "#FF5500",
                  width: "200px",
                }}
                size="sm"
                onClick={() => navigate("/user")}
              >
                Accéder au tableau de bord
              </Button>
            </div>
          </div>
        </p>
      </div>
      <GuideSection {...nextStepsGuide} />
    </Container>
  );
}

export default FormalityFinalization;
